import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class GetPublicAlbumAPICall extends APICallV4 {
    _method = 'public/album/get';
    _type: Method = 'get';
}
